import { useMemo } from 'react';

import { useI18n } from '@change-corgi/core/react/i18n';

import type { AdvocateAvatarProps } from '../../../types';
import { HAS_ADVOCATES_STATE } from '../../../util';

export const useAdvocateInfo = ({ hasAdvocatesState, petitionAdvocates }: AdvocateAvatarProps) => {
	const { translate, translatePlural } = useI18n();

	const title = useMemo(() => {
		if (hasAdvocatesState === HAS_ADVOCATES_STATE.none) return translate('corgi.petition.advocates.community_petition');
		if (hasAdvocatesState === HAS_ADVOCATES_STATE.one) return translate('corgi.petition.advocates.petition_advocate');
		return translate('corgi.petition.advocates.petition_advocates');
	}, [hasAdvocatesState, translate]);

	const subtitle = useMemo(() => {
		if (hasAdvocatesState === HAS_ADVOCATES_STATE.none)
			return translate('corgi.petition.details.updates.petition_starter');

		const firstAdvocate = petitionAdvocates?.[0];
		if (!firstAdvocate) return '';

		const name = `${firstAdvocate.firstName} ${firstAdvocate.lastInitial}`;
		if (hasAdvocatesState === HAS_ADVOCATES_STATE.one) return name;

		const othersCount = petitionAdvocates.length - 1;
		return translatePlural('corgi.petition.advocates.others', othersCount, {
			name,
			count: othersCount.toString(),
		});
	}, [hasAdvocatesState, petitionAdvocates, translatePlural, translate]);

	const hasExtraAdvocates = useMemo(() => {
		return hasAdvocatesState === HAS_ADVOCATES_STATE.multiple;
	}, [hasAdvocatesState]);

	return { title, subtitle, hasExtraAdvocates };
};
